import { AnyAction } from 'redux';
import { DraftConfiguration } from '@/types';
import { matchTextAgainstBlocklist } from '@/utils/text/matchTextAgainstBlocklist';
import { isDraftConfigurationWithTextOrSpecialText } from '@/model/configuration/isDraftConfigurationType';
import { Thunk } from '@/redux/types';
import { setValidationAction } from '@/components/draft/draftState/actions/setValidationAction';
import { getConfiguration } from '../getters/getConfiguration';
import { getConfigurationErrors } from '../getters/getConfigurationErrors';

export const matchTextAgainstBlocklistAction =
  ({ cid }: DraftConfiguration, text: string): Thunk<void, AnyAction> =>
  async (dispatch, getState) => {
    const copyrightError = await matchTextAgainstBlocklist(text.replace(/\s+/g, ' '));
    const configuration = getConfiguration(getState(), cid);
    // are we still checking against the current version
    if (
      !(configuration && configuration.type !== 'design' && configuration.text.content === text)
    ) {
      return;
    }

    // update the error or remove it if it is currently set
    if (
      isDraftConfigurationWithTextOrSpecialText(configuration) &&
      (copyrightError || getConfigurationErrors(getState(), cid)?.copyright)
    ) {
      getState().draftDispatch(setValidationAction({ [cid]: { copyright: copyrightError } }));
    }
  };
